// Integer cents throughout. Invoice amounts are supplied only by the server's payable context.
export function moneyLabel(cents, currency = 'usd') {
    if (!Number.isSafeInteger(cents)) return '—';
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency.toUpperCase() }).format(cents / 100);
}
export function parseTipCents(value) {
    const text = String(value ?? '').trim();
    if (!/^\d{1,5}(\.\d{1,2})?$/.test(text)) return null;
    const [whole, fraction = ''] = text.split('.');
    return Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
}
export function presetTipCents(fareCents, percent) {
    if (!Number.isSafeInteger(fareCents) || fareCents <= 0 || ![15, 20, 25].includes(percent)) return null;
    return Math.round(fareCents * percent / 100);
}
export function paymentStatusLabel(status) {
    return ({ canceled: 'Canceled before payment', completed: 'Paid', paid: 'Paid', succeeded: 'Paid', processing: 'Waiting for confirmation', pending: 'Waiting for confirmation',
        requires_action: 'Confirmation needed', failed: 'Payment didn’t go through', refunded: 'Refunded',
        partially_refunded: 'Partly refunded', 'partially-refunded': 'Partly refunded', owed: 'Owed to your driver',
        transferred: 'Sent to your driver' })[status] || 'Waiting for confirmation';
}
export const paymentFailure = () => 'We couldn’t complete that payment. Check Payments for confirmation before trying again. If it keeps happening, contact your account team.';
